"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOfferer = void 0;
const crypto_1 = __importDefault(require("crypto"));
const getOfferer = (localNodeId, remoteNodeId) => {
    return getOfferingHash(localNodeId + ',' + remoteNodeId) < getOfferingHash(remoteNodeId + ',' + localNodeId)
        ? 'local'
        : 'remote';
};
exports.getOfferer = getOfferer;
const getOfferingHash = (idPair) => {
    const buffer = crypto_1.default.createHash('md5').update(idPair).digest();
    return buffer.readInt32LE(0);
};
//# sourceMappingURL=offering.js.map